<div class="map-container" [hidden]="isMapLoading" >
    <div id="map-create-route">
    </div>
</div>
<div class="flex items-center h-full justify-center" *ngIf="isMapLoading">
    <lazy-loader></lazy-loader>
</div>
